module.exports = __webpack_public_path__ + "img/demo-upgrade.be51758e.png";